import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";

const LegalModals = ({ showImpressum, showDatenschutz, onCloseImpressum, onCloseDatenschutz }) => {
  return (
    <>
      {/* Impressum Modal */}
      <Dialog open={showImpressum} onOpenChange={onCloseImpressum}>
        <DialogContent className="max-w-2xl max-h-[80vh]" data-testid="impressum-modal">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl font-bold text-komel-primary">
              Impressum
            </DialogTitle>
            <DialogDescription className="sr-only">
              Rechtliche Informationen und Impressum der Komel AG
            </DialogDescription>
          </DialogHeader>
          <ScrollArea className="h-[60vh] pr-4">
            <div className="space-y-6 text-komel-secondary">
              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Verantwortliche Stelle
                </h3>
                <p>
                  Komel AG<br />
                  Multergasse 2a<br />
                  9000 St. Gallen<br />
                  Schweiz
                </p>
                <p className="mt-2">
                  Telefon: 071 226 11 99
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Handelsregistereintrag
                </h3>
                <p>
                  Eingetragener Firmenname: Komel AG<br />
                  Handelsregister des Kantons St. Gallen
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Zweck des Unternehmens
                </h3>
                <p>
                  Total- und Generalunternehmung im Bauwesen. Planung, Koordination und Ausführung 
                  von Neubauten, Sanierungen und Renovationen.
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Haftungsausschluss
                </h3>
                <p>
                  Der Autor übernimmt keine Gewähr für die Richtigkeit, Genauigkeit, Aktualität, 
                  Zuverlässigkeit und Vollständigkeit der Informationen. Haftungsansprüche gegen 
                  den Autor wegen Schäden materieller oder immaterieller Art, die aus dem Zugriff 
                  oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch 
                  Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden 
                  ausgeschlossen.
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Urheberrechte
                </h3>
                <p>
                  Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen 
                  Dateien auf dieser Website gehören ausschliesslich der Komel AG oder den speziell 
                  genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die 
                  schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.
                </p>
              </section>
            </div>
          </ScrollArea>
        </DialogContent>
      </Dialog>

      {/* Datenschutz Modal */}
      <Dialog open={showDatenschutz} onOpenChange={onCloseDatenschutz}>
        <DialogContent className="max-w-2xl max-h-[80vh]" data-testid="datenschutz-modal">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl font-bold text-komel-primary">
              Datenschutzerklärung
            </DialogTitle>
            <DialogDescription className="sr-only">
              Datenschutzerklärung der Komel AG
            </DialogDescription>
          </DialogHeader>
          <ScrollArea className="h-[60vh] pr-4">
            <div className="space-y-6 text-komel-secondary">
              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Verantwortliche Stelle
                </h3>
                <p>
                  Komel AG<br />
                  Multergasse 2a<br />
                  9000 St. Gallen<br />
                  Schweiz<br />
                  Telefon: 071 226 11 99
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Kontaktformular
                </h3>
                <p>
                  Wenn Sie uns über das Kontaktformular kontaktieren, werden Ihre Angaben 
                  (Name, E-Mail-Adresse, Telefonnummer, Anliegen und Nachricht) zur Bearbeitung 
                  Ihrer Anfrage gespeichert. Diese Daten werden nicht ohne Ihre Einwilligung 
                  an Dritte weitergegeben.
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Datenverarbeitung
                </h3>
                <p>
                  Wir verarbeiten Ihre personenbezogenen Daten nur, soweit dies zur Bereitstellung 
                  einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. 
                  Die Verarbeitung personenbezogener Daten erfolgt nur nach Einwilligung des Nutzers.
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Server-Logs
                </h3>
                <p>
                  Der Hosting-Provider dieser Website erhebt und speichert automatisch Informationen 
                  in sogenannten Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies sind:
                </p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Browsertyp und -version</li>
                  <li>Verwendetes Betriebssystem</li>
                  <li>Referrer URL</li>
                  <li>Hostname des zugreifenden Rechners</li>
                  <li>Uhrzeit der Serveranfrage</li>
                  <li>IP-Adresse</li>
                </ul>
                <p className="mt-2">
                  Diese Daten werden nicht mit anderen Datenquellen zusammengeführt.
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Google Maps
                </h3>
                <p>
                  Diese Website nutzt Google Maps zur Darstellung von Kartenmaterial. Bei der 
                  Nutzung von Google Maps werden von Google auch Daten über die Nutzung der 
                  Kartenfunktionen durch Besucher erhoben, verarbeitet und genutzt. Nähere 
                  Informationen über die Datenverarbeitung durch Google können Sie den 
                  Google-Datenschutzhinweisen entnehmen.
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Ihre Rechte
                </h3>
                <p>
                  Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger 
                  und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben 
                  ausserdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. 
                  Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit 
                  an uns wenden.
                </p>
              </section>

              <section>
                <h3 className="font-heading font-semibold text-komel-primary mb-2">
                  Änderungen
                </h3>
                <p>
                  Wir können diese Datenschutzerklärung jederzeit ohne Vorankündigung anpassen. 
                  Es gilt die jeweils aktuelle, auf unserer Website publizierte Fassung.
                </p>
              </section>
            </div>
          </ScrollArea>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LegalModals;
